// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyC7nrPkRbkwlgmZSyGiSflUgoR9AHaqTtY",
    authDomain: "docmed-health-care.firebaseapp.com",
    projectId: "docmed-health-care",
    storageBucket: "docmed-health-care.appspot.com",
    messagingSenderId: "331189985407",
    appId: "1:331189985407:web:51d428073001b7a3ef9f4a"
  };

  export default firebaseConfig;
  